"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableWithCollapse = void 0;
var TableData_1 = require("./TableData");
Object.defineProperty(exports, "TableWithCollapse", { enumerable: true, get: function () { return __importDefault(TableData_1).default; } });
// export { default as MobileDataTable } from './MobileDataTable'
